<template>
    <SOSlotBase :bg-white="true" :loading="pageSetting.loading">
        <template v-slot:loading-page>
            <SOLoadingPage />
        </template>

        <template v-slot:title-bar>
            <SOTitleBar page-title="Masa Aktif Poin" :type="'back'" @back="back" />
        </template>

        <template v-slot:content>
            <div id="form_container" class="d-flex-column justify-content-between min p-x-20 p-y-20">
				<div>
					<div
						:class="
							`custom-control row custom-radio p-y-12 p-x-16 border rounded-lg ${
								radio.value == selectedOption ? 'option-selected' : ''
							} ${idx > 0 ? 'mt-2' : ''}`
						"
						v-for="(radio, idx) in options"
						:key="`radio-${idx}`"
						@click="onSelect(radio.value)"
					>
						<input
							class="custom-control-input"
							type="radio"
							:id="`radio-${idx}`"
							:name="`options-radio`"
							:value="radio.value"
							:checked="radio.value == selectedOption"
						/>
						<label class="custom-control-label f-regular f-16 f-c-primary" :for="`radio-${idx}`">
							{{ radio.title }}
						</label>
						<div class="option-information">
							<label
								class="f-regular f-c-midgrey f-12 m-d-0 ml-4" 
								:for="`radio-${idx}`"
							>
								<span class="f-bold">Periode: </span>{{ radio.detail }}
							</label>
						</div>
					</div>
				</div>
                <SOButton
                    text="Simpan"
                    :primary="true"
                    :full="true"
                    :disable="isDisable"
                    :loading="isLoading"
                    @action="onSave()"
                />
            </div>
        </template>
    </SOSlotBase>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "@/modules/pengaturan-umum/store/state";
import SOInputNominal from "@/so-components/global/input/SOInputNominal";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOSlotCard from "@/so-components/global/slot/SOSlotCard";
import ErrorMessage from "@/component-items/ErrorMessage";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputRadioBig from "@/so-components/global/input/SOInputRadioBig.vue";

export default {
    name: "PointActivePeriod",
    components: {
    SOSlotBase,
    SOLoadingPage,
    SOTitleBar,
    SOSlotCard,
    SOInputNominal,
    ErrorMessage,
    SOButton,
    SOInputRadioBig
},
    computed: {
        ...mapGetters("pengaturanUmumModule", {
            pointActivePeriod: "pointActivePeriod",
        }),
        isDisable() {
            return this.isLoading || this.selectedOption == this.pointActivePeriod
        }
    },
    data() {
        return {
            pageSetting: {
                loading: false,
                hiddenOptions: false,
            },
            isLoading: false,
			options: [
				{
					title:'Unlimited',
					id: '0',
					value:'unlimited',
					detail: 'Selamanya'
				},
				{
					title:'Quartal (3 Bulan)',
					id: '1',
					value:'quartal',
					detail: 'Januari-Maret, April-Juni, Juli-September, Oktober-Desember'
				},
				{
					title:'Semester (6 Bulan)',
					id: '2',
					value:'semester',
					detail: 'Januari-Juni, Juli-Desember'
				},
				{
					title:'Tahunan (1 Tahun)',
					id: '3',
					value:'tahunan',
					detail: 'Januari-Desember'
				},
			],
			selectedOption: 0
        };
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        ...mapActions(moduleName, {
            getSettingsV2: "getSettingsV2",
            updateActivePeriodPoint: "updateActivePeriodPoint",
        }),
        onSelect(v) {
			this.selectedOption = v
		},
        back() {
            this.$router.push({ name: "pengaturanUmum.dashboard" });
        },
        async getInfo() { 
            this.pageSetting.loading = true;
            this.getSettingsV2().then(r => {
                this.onSelect(this.pointActivePeriod);
            }).catch((err) => {
				this.$toast.error(err);
                console.log(err);
            }).finally(() => this.pageSetting.loading = false)

            setTimeout(() => {
                $(".card-body").addClass("card-body-no-footer");
            }, 100);
        },
        async onSave() {
            this.isLoading = true;
            this.updateActivePeriodPoint(this.selectedOption).then((result) => {
                if (result.success) {
                    this.$toast.success('Berhasil memperbarui masa aktif cashback')
                    this.$router.back()
                }
                else this.$toast.error(result.err)
            }).catch((err) => {
                this.$toast.error(err)
            }).finally(() => this.isLoading = false)
        }
    },
    beforeDestroy() {
        $(".card-body").removeClass("card-body-no-footer");
    },
};
</script>

<style>
.card-body-no-footer {
    border-bottom: none !important;
    padding-bottom: 0 !important;
}
#form_container {
    min-height: calc(100vh - 177px);
}
.radio-group label ::after {
	background: #000;
}
.option-selected {
    background: #f0f7ff;
}
</style>
